const view = /*html*/`

    
    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">
        <style>
            /*.top-rank:nth-of-type(1)::after, .top-rank:nth-of-type(2)::after, .top-rank:nth-of-type(3)::after {
                content: "";
                position: absolute;
                left: 0px;
                top: 0px;
                height: 100%;
                width: 100%;
                z-index: 0;                 
                border: 0;
                box-sizing: border-box;
                color: #fff;
                margin: 0;
                padding: 0;
            }
            .top-rank:nth-of-type(1)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 60.91%, rgba(52, 49, 43, 0.4) 77.74%, rgba(255, 193, 7, 0.4) 102.88%);
            }
            .top-rank:nth-of-type(2)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 58.44%, rgba(39, 50, 70, 0.4) 78.79%, rgba(71, 94, 138, 0.4) 100%);
            }
            .top-rank:nth-of-type(3)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.3) 61.73%, rgba(51, 43, 44, 0.3) 80.47%, rgba(119, 78, 55, 0.3) 100%);
            }*/

            .top-bg-1{
                background: linear-gradient(to right, rgba(255, 193, 7, 0.45) 0px, rgb(68, 57, 37) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%);
            }
            .top-bg-2{
                background: linear-gradient(to right, rgba(71, 94, 138, 0.45) 0px, rgb(54, 54, 69) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%);
            }
            .top-bg-3{
                background: linear-gradient(to right, rgba(119, 78, 55, 0.45) 0px, rgb(75, 52, 28) 26rem, rgb(27, 27, 27) 74rem, rgba(31, 31, 31, 0.5) 100%);
            }

            .top-trophy-1{
                color: #ffc107;
            }
            .top-trophy-2{
                color: #C0C0C0;
            }
            .top-trophy-3{
                color: #CD7F32;
            }
            .table-custom
            {
                border-collapse: separate;
                border-spacing: 0 0.45rem;
            }
            
        </style>
        <div class="card card-flush w-100 bgi-position-x-end bgi-position-y-center mb-6 px-20" style="height:246px;background-image:url('assets/media/misc/bg_players.png');">
            <div class="d-flex h-100 align-items-center">
                <div class="card-title">
                    <h1 class="fs-2hx text-white teko-header" data-i18n="players.title">Players Ranking</h1>
                    <p class="text-gray-700 fs-6" data-i18n="players.subtitle">Play ranked matches, show us your skills and get to the top of the rank!</p>
                </div>
            </div>            
        </div>

        <!--<div class="card w-100 mb-6">
            <div class="card-body">
                <div class="d-flex flex-stack">
                    <div class="d-flex flex-row flex-wrap gap-6">                        
                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_10.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">2000+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_9.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">1850+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_8.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">1700+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_7.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">1550+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_6.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">1400+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_5.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">1250+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_4.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">1100+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_3.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">950+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_2.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">800+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_1.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white">0+</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column gap-3 align-items-center justify-content-center">
                            <div class="symbol symbol-60px">
                                <img src="assets/media/ranks/rank_0.png">
                            </div>
                            <div class="text-center">
                                <span class="badge text-white text-uppercase" data-i18n="players.norank">No Ranked</span>
                            </div>
                        </div>
                    </div>

                    <div class="">
                        <a data-navigo href="services/faq" class="btn btn-bg-primary btn-color-zblack btn-active-color-white btn-sm px-4 text-nowrap lobby-btn-connect" data-i18n="players.whats">What's Rating?</a>
                    </div>
                </div>             
            </div>
        </div>-->

        <div class="card card-flush shadow-none mb-4">
            <div class="card-header border-0 px-4">
                <!--begin::Card title-->
                <div class="card-title">
                    <!--begin::Search-->
                    <div class="d-flex align-items-center position-relative my-1 d-none">
                        <i class="ki-outline ki-magnifier fs-3 position-absolute ms-5"></i>
                        <input type="text" data-kt-customer-table-filter="search" class="form-control form-control-solid w-250px ps-12" placeholder="Search Customers">
                    </div>
                    <!--end::Search-->
                    
                    <div class="d-flex align-items-center flex-wrap">                        
                        <div class="flex-shrink-0 me-2">
                            <ul class="nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <span class="nav-link btn btn-sm btn-color-muted btn-active-color-primary btn-active-light active fw-semibold fs-7 px-4 me-1 text-uppercase" data-bs-toggle="tab" href="#" aria-selected="true" role="tab">Global</span>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <span class="nav-link btn btn-sm btn-color-muted btn-active-color-primary btn-active-light fw-semibold fs-7 px-4 me-1 text-uppercase" data-bs-toggle="tab" href="#" aria-selected="false" tabindex="-1" role="tab">Week</span>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <span class="nav-link btn btn-sm btn-color-muted btn-active-color-primary btn-active-light fw-semibold fs-7 px-4 text-uppercase" data-bs-toggle="tab" href="#" aria-selected="false" tabindex="-1" role="tab">Day</span>
                                </li>
                            </ul>
                        </div>
                        <!--end::Wrapper-->
                    </div>

                </div>
                <!--begin::Card title-->

                <!--begin::Card toolbar-->
                <div class="card-toolbar">
                    <!--begin::Toolbar-->
                    <div class="d-flex justify-content-end min-w-225px">
                        <select class="form-select form-select-sm form-select-solid" id="rank-filter-country">                            
                        </select>
                    </div>
                    <!--end::Toolbar-->
                </div>
                <!--end::Card toolbar-->
            </div>
        </div>

        <!--begin::FAQ card-->
        <div class="card card-flush bg-transparent">           
            
                <!--begin::Table container-->
                <div class="table-responsive">
                    <!--begin::Table-->
                    <table class="table table-custom align-middle gs-0 gy-4">
                        <!--begin::Table head-->
                        <thead>
                            <tr class="fw-bold text-gray-800 teko-semibold fs-4" style="background-color: #1b1b1b">
                                <th class="ps-4 rounded-start min-w-75px">Pos</th>
                                <th class="min-w-250px" data-i18n="stats.player">Player Name</th>
                                <th class="min-w-125px"><span data-i18n="stats.rank">Rank</span> / Rating</th>                                
                                <th class="min-w-75px" data-i18n="stats.matches">Matches</th>
                                <th class="min-w-75px"><span data-i18n="stats.win">Win</span>(%)</th>                                
                                <th class="min-w-75px text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr">ADR</th>
                                <th class="min-w-75px text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tkdr;[data-bs-original-title]stats.tkdr">KDR</th>
                                <th class="min-w-75px" data-i18n="stats.kills">Kills</th>
                                <th class="min-w-75px" data-i18n="stats.deaths">Deaths</th>
                                <th class="text-nowrap rounded-end pe-4 min-w-75px" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HS / HS%</th>
                                <!--<th class="text-nowrap rounded-end pe-4 min-w-75px" data-i18n="stats.winrate">% Win</th>-->
                                <!--<th class="text-nowrap text-end rounded-end pe-4 min-w-75px">% Lose</th> -->
                            </tr>
                        </thead>
                        <!--end::Table head-->

                        <!--begin::Table body-->
                        <tbody class="table-players-body position-relative">                            
                        </tbody>
                        <!--end::Table body-->
                    </table>
                    <!--end::Table-->
                </div>
                <!--end::Table container-->
        </div>
        <!--end::FAQ card-->
    </div>
    <!--end::Container-->

`;


export default view;